import React from "react";
import MBreadcrumbs from "@mui/material/Breadcrumbs";

const Breadcrumbs = (props) => {
    return <MBreadcrumbs {...props} />
}

export default React.memo(Breadcrumbs);